var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.334 4.16676L15.834 6.66676M7.50075 5.89176C6.03891 6.10005 4.71045 6.85497 3.78335 8.00425C2.85624 9.15353 2.39949 10.6116 2.50522 12.0845C2.61095 13.5573 3.27129 14.9352 4.35305 15.9403C5.43481 16.9453 6.85748 17.5028 8.33408 17.5001C9.73691 17.5003 11.0928 16.9949 12.1533 16.0766C13.2138 15.1583 13.9078 13.8885 14.1083 12.5001M10.0007 12.5001L16.9882 5.48759C17.3164 5.15938 17.5008 4.71424 17.5008 4.25009C17.5008 3.78594 17.3164 3.34079 16.9882 3.01259C16.66 2.68438 16.2149 2.5 15.7507 2.5C15.2866 2.5 14.8414 2.68438 14.5132 3.01259L7.50071 10.0001V12.5001H10.0007Z",
    stroke: "#C7C7C7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/editIcon.6869f0d98e33246520373b1256b2af86.svg";
export { ForwardRef as ReactComponent };